<template>
  <div>
    <el-row :gutter="20">
      <!-- <el-col :xs="{ span: 24 }" :sm="{ span: 6}">
        <el-select v-model="cladeType" size="small" style="width: 100%" @change="cladeTypeChange">
          <el-option label="Nextstrain Clade" value="nextstrain_clade"></el-option>
          <el-option label="Pangolin lineage" value="pangolin_lineage"></el-option>
        </el-select>
      </el-col> -->
      

    </el-row>
    
    <el-row id="clade-area-plot" style="margin-top: 30px">
      <situation-clade-frequency-timeline-area :lineages="lineages"
        :startDate="startDate" :endDate="endDate" height="40vh"
        :key="startDate+endDate+lineages.join('')">
      </situation-clade-frequency-timeline-area>
    </el-row>

  </div>
</template>

<script>
import { store } from '@/scripts/store.js';
import PostService from '@/scripts/post_service.js'

require ('echarts/theme/infographic');

const _ = require('lodash')

export default {
  name: 'GenomeCladeTimeline',
  components: {
    SituationCladeFrequencyTimelineArea: () => import('@/components/situation/SituationCladeFrequencyTimelineArea.vue')
  },
  created() {
  },
  props: {
    startDate: String,
    endDate: String,
    lineages: Array
  },
  data() {
    const clades = _.filter(store.constants.clades, c => { return c !== 'Unassigned'})
    return { 
      store: store,
      cladeSelect: clades,
      cladeType: "pangolin_lineage",
      plotWidth: 0,
      requiredRows: 1,
      states: _.map(store.constants.states, s => { return { value: s.name, label: s.name } }),
    } 
  },
  mounted() {
    const context = this
  },
  computed: {
  },
  methods: {
    
    // async cladeTypeChange(val) {
    //   const context = this
    //   console.log('cladeTypeChanged')
    //   if (val === 'nextstrain_clade') {
    //     context.cladeFrequencyData = await PostService.getPlotData('cladeFrequencyTimeline')
    //     context.updateCladeFrequencyTimeline += 1
    //   }
    //   else {
    //     console.log(val)
    //     context.pangolinLineages = [] //await PostService.getPlotData('topPangolinLineages', { startDate: this.startDate, endDate: this.endDate})
    //     context.pangolinLineages = _.map(context.pangolinLineages, 'pangolin_lineage')
    //     console.log(context.pangolinLineages)
    //     const  query = 'pangolinFrequencyTimeline&lineage[]='+ context.pangolinLineages.join('&lineage[]=')
    //     context.cladeFrequencyData = await PostService.getPlotData(query)
    //     context.updateCladeFrequencyTimeline += 1
    //   }
    // },

  },
}
</script>

<style>

  .select-state .el-select__tags span .el-tag {
    color: #E54138 !important;
    background-color: white;
    border: 1px solid #ff9f9a;
    
  }

  .select-state .el-select__tags span .el-tag i {
    color: white;
    background-color: #E54138;
    border: none;
    margin-right: 5px;
  }
  .select-state.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
    color: #E54138;
  }
  .select-state.el-select .el-input.is-focus .el-input__inner {
    border-color: #E54138 !important;
  }

  .clade-checkbox.el-checkbox-button.is-focus .el-checkbox-button__inner{
    border-color: #E54138 !important;
  }
  .clade-checkbox.el-checkbox-button.is-focus .el-checkbox-button__inner:hover{
    color: #000000 !important;
  }
  .clade-checkbox.el-checkbox-button .el-checkbox-button__inner:hover{
    color: #000000 !important;
  }
</style>